import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { whatsappLink } from "@/constants/site";
import { resellerProgram } from "@/mocks/home";

export default function ResellerProgram() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-700">
                <i className="ri-store-2-line" aria-hidden="true"></i>
                Programa de revenda
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Revenda hospedagem e soluções com a sua marca.
              </h2>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600">
                Se você atende empresas e quer ampliar as suas ofertas, torne-se um parceiro NXHOST.
                Você revende hospedagem, domínios e soluções digitais com condições especiais e a
                infraestrutura pronta para você crescer.
              </p>

              <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {resellerProgram.benefits.map((benefit, index) => (
                  <Reveal key={benefit.title} delay={index * 60}>
                    <div className="flex h-full items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-4">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                        <i className={`${benefit.icon} text-lg`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <p className="font-heading text-sm font-semibold text-foreground-950">
                          {benefit.title}
                        </p>
                        <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                          {benefit.description}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to="/revenda"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  Conhecer o programa de revenda
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <a
                  href={whatsappLink("Ola! Quero conhecer o programa de revenda da NXHOST.")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-50/60"
                >
                  <i className="ri-whatsapp-line text-lg text-secondary-600" aria-hidden="true"></i>
                  Falar com um especialista
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative overflow-hidden rounded-2xl bg-foreground-950 p-6 text-background-50 md:p-8">
              <div className="absolute inset-0 nx-grid opacity-25"></div>
              <div className="nx-glow absolute -bottom-16 right-0 h-72 w-72 animate-pulseGlow"></div>

              <div className="relative">
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-accent-300">
                    <i className="ri-vip-crown-2-line" aria-hidden="true"></i>
                    Seja um parceiro
                  </span>
                  <span className="flex items-center gap-2">
                    <span className="h-2 w-2 rounded-full bg-secondary-400"></span>
                    <span className="text-[11px] text-background-300">Vagas abertas</span>
                  </span>
                </div>

                <p className="mt-6 text-sm text-background-300">Planos de revenda a partir de</p>
                <div className="mt-1 flex items-end gap-1">
                  <span className="text-base font-medium text-background-300">R$</span>
                  <span className="font-heading text-5xl font-bold text-background-50">
                    {resellerProgram.priceFrom}
                  </span>
                  <span className="mb-2 text-sm text-background-400">/mês</span>
                </div>

                <div className="mt-6 space-y-3">
                  <ResellerRow icon="ri-window-line" label="Contas de clientes" value="Você gerencia" />
                  <ResellerRow icon="ri-user-star-line" label="Sua marca" value="Sim" />
                  <ResellerRow icon="ri-map-pin-2-line" label="Infraestrutura" value="No Brasil" />
                </div>

                <div className="mt-6 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3">
                  <p className="text-xs leading-relaxed text-background-300">
                    Estrutura pronta para você começar a revender sem se preocupar com a parte técnica.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function ResellerRow({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3">
      <span className="flex items-center gap-2.5 text-sm text-background-200">
        <i className={`${icon} text-lg text-accent-300`} aria-hidden="true"></i>
        {label}
      </span>
      <span className="text-sm font-semibold text-background-50">{value}</span>
    </div>
  );
}